export const pythonBuiltins : Record<string, { type: "module", documentation?: string }> = 
{
    // The modules are manually inferred from Skulpt https://github.com/skulpt/skulpt/tree/master/src/lib
    // Anything that appears to be implemented is listed here:
    "test": {type: "module", documentation: "Regression tests package for Python."},
    "unittest": {type: "module", documentation: "Unit testing framework."},
    "urllib": {type: "module", documentation: "URL handling modules."},
    "urllib.request": {type: "module", documentation: "Extensible library for opening URLs."},
    "webgl": {type: "module"},
    "antigravity": {type: "module"},
    "array": {type: "module", documentation: "Efficient arrays of numeric values."},
    "bisect": {type: "module", documentation: "Array bisection algorithm."},
    "collections": {type: "module", documentation: "Container datatypes."},
    "copy": {type: "module", documentation: "Shallow and deep copy operations."},
    "datetime": {type: "module", documentation: "Basic date and time types."},
    "document": {type: "module"},
    "image": {type: "module"},
    "itertools": {type: "module", documentation: "Functions creating iterators for efficient looping."},
    "keyword": {type: "module", documentation: "Testing for Python keywords."},
    "math": {type: "module", documentation: "Mathematical functions."},
    "numbers": {type: "module", documentation: "Numeric abstract base classes."},
    "operator": {type: "module", documentation: "Standard operators as functions."},
    "platform": {type: "module", documentation: "Access to underlying platform’s identifying data."},
    "processing": {type: "module"},
    "random": {type: "module", documentation: "Generate pseudo-random numbers."},
    "re": {type: "module", documentation: "Regular expression operations."},
    "signal": {type: "module", documentation: "Set handlers for asynchronous events."},
    "string": {type: "module", documentation: "Common string operations."},
    "textwrap": {type: "module", documentation: "Text wrapping and filling."},
    "time": {type: "module", documentation: "Time access and conversions."},
    "token": {type: "module", documentation: "Constants used with Python parse trees."},
    "tokenize": {type: "module", documentation: "Tokenizer for Python source."},
    "types": {type: "module", documentation: "Dynamic type creation and names for built-in types."},
    "webbrowser": {type: "module", documentation: "Convenient web-browser controller."},
    "turtle": {type: "module", documentation: "Implementation of the Turtle graphics."},
};
